import axios from "axios";
import NProgress from "nprogress";
import router from "@/router";
import "nprogress/nprogress.css";

const service = axios.create({
  baseURL: process.env.VUE_APP_APP,
  withCredentials: true,
  headers: {
    Referer: window.location.href,
    platformType: "SC",
    "Cache-Control": "no-cache"
  }
});

service.interceptors.request.use(config => {
  NProgress.start();
  return config;
});

service.interceptors.response.use(
  response => {
    NProgress.done();

    const { status, data } = response;

    if (status === 403) {
      router.push("/403");
      return false;
    }

    if (status >= 404 && status < 422) {
      router.push("/404");
      return false;
    }

    if (status <= 504 && status >= 500) {
      router.push("/500");
      return false;
    }

    if (data.code === 20003) {
      window.location.href = `${process.env.VUE_APP_CAS}account/login?service=${
        process.env.VUE_APP_APP
      }&systemId=20&retUrl=${encodeURIComponent(window.location.href)}`;
      return Promise.reject();
    }

    return data;
  },
  error => {
    // eslint-disable-next-line
    console.log(`接口信息：${error.msg}` || "系统繁忙");
    return Promise.reject(error);
  }
);

export default service;
